<template>

    <div v-if="team.has_share_company_access">
        <div>
            <b-tabs content-class="mt-3" lazy>
                <b-tab title="My Companies" active>
                    <my-companies
                        :masks="masks"
                        :symbols="symbols"
                        :user-role="userRole"
                        :state="state"
                        :available-columns="availableColumns"
                        :available-sort="availableSort"
                        :custom-fields="customFields"
                        :can-delete="canDelete"
                        :custom-field-type-constants="customFieldTypeConstants"
                        :user-item-per-page="userItemPerPage"
                        :company-user-view-list="companyUserViewList"
                        :can-create="canCreate">
                    </my-companies>
                </b-tab>
                <b-tab title="Shared Companies">
                    <shared-companies
                        :masks="masks"
                        :symbols="symbols"
                        :user-role="userRole"
                        :state="state"
                        :available-columns="availableColumns"
                        :available-sort="availableSort"
                        :custom-fields="customFields"
                        :shared-available-columns="sharedAvailableColumns">
                    </shared-companies>
                </b-tab>
            </b-tabs>
        </div>
    </div>
    <div v-else>
        <my-companies
            :masks="masks"
            :symbols="symbols"
            :user-role="userRole"
            :state="state"
            :available-columns="availableColumns"
            :available-sort="availableSort"
            :custom-fields="customFields"
            :can-delete="canDelete"
            :custom-field-type-constants="customFieldTypeConstants"
            :user-item-per-page="userItemPerPage"
            :company-user-view-list="companyUserViewList"
            :can-create="canCreate">
        </my-companies>
    </div>

</template>

<script>
    export default {
        name:'company-index',
        props:{
            availableColumns: {
                type: Array,
            },
            masks: {},
            state: {
                type: Array,
            },
            symbols: {},
            userRole:{},
            availableSort: {},
            customFields: {
                type: Array,
            },
            team: {},
            sharedAvailableColumns: {
                type: Array
            },
            canDelete: {},
            customFieldTypeConstants: {},
            userItemPerPage:{},
            companyUserViewList: {
                type: Array
            },
            canCreate: {}
        },
    }
</script>
